import { RouteEnum } from '../Utilities/Enums/RouteEnums';

export const GlobalConstants = {
    DEFAULT_FONT_SIZE: '0.875rem',
    LEGEND_FONT_SIZE: '0.75rem',
    DRAWER_WIDTH: 240,
}

export const GlobalSettingsConstants = {
    STRIPE_PUBLISHABLE_KEY: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY,
    STRIPE_RETURN_URL: process.env.REACT_APP_WEB_URL + RouteEnum.BUY_LICENSE,
    RECAPTCHA_API_KEY: process.env.REACT_APP_RECAPTCHA_API_KEY,
}